module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/events-calculator/events-travel/events-travel.component.html
// module id = ./src/app/components/calculator/calculator-item/events-calculator/events-travel/events-travel.component.html
// module chunks = main